import { render, staticRenderFns } from "./VehicleMapV2.vue?vue&type=template&id=06385f5b&scoped=true"
import script from "./VehicleMapV2.vue?vue&type=script&lang=js"
export * from "./VehicleMapV2.vue?vue&type=script&lang=js"
import style0 from "./VehicleMapV2.vue?vue&type=style&index=0&id=06385f5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06385f5b",
  null
  
)

export default component.exports